import React, { useState } from 'react';
import CollapsibleSection from './CollapsibleSection';
import TestBoxplot from './TestBoxplot';

function DiagnosisFinding({ finding, findTestData, className = '' }) {
    const getWeightClass = (weight) => {
        if (weight >= 0.5) return 'high';
        if (weight >= 0.1) return 'moderate';
        return 'low';
    };

    const getTestName = (marker) => {
        const testData = findTestData(marker.marker);
        return testData ? (testData.alias || testData.test_name) : marker.marker;
    };

    return (
        <div className={`diagnosis-finding ${className}`}>
            <CollapsibleSection
                title={
                    <div className="diagnosis-header-content">
                        <span className="diagnosis-name">{finding.diagnosis}</span>
                        <span className={`weight-badge ${getWeightClass(finding.total_weight)}`}>
                            {finding.total_weight.toFixed(3)}
                        </span>
                    </div>
                }
                defaultOpen={false}
                className="diagnosis-section"
            >
                <div className="contributing-markers">
                    {finding.contributing_markers?.map((marker, idx) => {
                        const testData = findTestData(marker.marker);
                        const testName = getTestName(marker);

                        return testData ? (
                            <CollapsibleSection
                                key={idx}
                                title={
                                    <div className="test-header-content">
                                        <span className="test-name">{testName}</span>
                                        <div className="test-info">
                                            <span className="test-value">
                                                {testData.result} {testData.units}
                                            </span>
                                            <span className="contribution">
                                                contrib: {marker.contribution.toFixed(3)}
                                            </span>
                                        </div>
                                    </div>
                                }
                                defaultOpen={false}
                                className="test-section"
                            >
                                <TestBoxplot
                                    testData={testData}
                                    markerContribution={marker.contribution}
                                    diagnosticKnots={marker.diagnostic_knots}
                                    diagnosisName={finding.diagnosis}
                                    showDetails={true}
                                    className="nested-boxplot"
                                />
                            </CollapsibleSection>
                        ) : (
                            <div key={idx} className="missing-test">
                                <span className="test-name">{marker.marker}</span>
                                <span className="contribution">contrib: {marker.contribution.toFixed(3)}</span>
                                <span className="missing-note">(Test data not found)</span>
                            </div>
                        );
                    })}
                </div>
            </CollapsibleSection>
        </div>
    );
}

export default DiagnosisFinding;